"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canDisplayChartTitles = void 0;
const data_1 = require("./data");
const create_selector_1 = require("../../../../state/create_selector");
exports.canDisplayChartTitles = (0, create_selector_1.createCustomCachedSelector)([data_1.getMetricSpecs], ([spec]) => {
    return (spec?.data?.length ?? 0) > 1 || (spec?.data?.[0]?.length ?? 0) > 1;
});
//# sourceMappingURL=can_display_chart_titles.js.map